module.exports = __webpack_public_path__ + "img/icon27.b419f36c.png";